module.exports = __webpack_public_path__ + "img/management-system.a5edc1b.png";